import React from "react";
import { Container, Row, Col, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/vision-mission-banner.webp";
import visionIcon from "../../Images/about/idea.webp";
import missionIcon from "../../Images/about/achievement.webp";
import valuesIcon from "../../Images/about/core-values.webp";
import visionImage from "../../Images/about/vision.webp";
import missionImage from "../../Images/about/mission.webp";
import researchLab from "../../Images/about/students-vision-mision.webp";

const VisionMission = () => {
  const coreValues = [
    {
      title: "Student Centricity",
      description:
        "Prioritizing student success in every initiative and decision.",
    },
    {
      title: "Academic Excellence",
      description:
        "Delivering high-quality, industry-relevant education and outcomes.",
    },
    {
      title: "Innovation",
      description:
        " Driving creative thinking and digital-first learning solutions.",
    },
    {
      title: "Integrity",
      description:
        "Maintaining transparency, trust, and ethics in all actions.",
    },
    {
      title: "Inclusivity",
      description:
        "Ensuring equal opportunities for learners from all backgrounds.",
    },
    {
      title: "Sustainability",
      description:
        " Advancing eco-conscious, socially responsible education practices.",
    },
  ];

  return (
    <React.Fragment>
      <title>
        Mission & Values: Commitment to Quality Academic Education
      </title>
      <meta
        name="description"
        content="ISBM University stands apart with its mission and values that put student support and community at the forefront of higher education."
      />

      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="Mission & Values: Commitment to Quality Academic Education"
      />
      <meta
        property="og:description"
        content="ISBM University stands apart with its mission and values that put student support and community at the forefront of higher education."
      />
      <meta
        property="og:url"
        content="https://isbmuniversity.edu.in/mission-values/"
      />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="Mission & Values: Commitment to Quality Academic Education"
      />
      <meta
        name="twitter:description"
        content="ISBM University stands apart with its mission and values that put student support and community at the forefront of higher education."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <meta
        name="keywords"
        content="isbm university, Student Support, Higher Education in chhattisgarh"
      />
      <Topnav />

      {/* Hero Banner */}
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Vission & Mission</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Vission & Mission
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* Vision Section */}
      <section className="vision-section ptb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="vision-image-container text-center">
                <img
                  src={visionIcon}
                  alt="Vision"
                  className="vision-icon mb-4"
                  width="120"
                />
                <h2 className="section-title modern-title text-blue">
                  Our Vision
                </h2>
                <blockquote className="blockquote m-0 vision-mission-statement">
                  <p className="mb-0 fs-4 fw-bold fst-italic">
                    "To be a student-centric university that facilitates
                    aspiring minds with virtues of knowledge, wisdom &
                    humanity."
                  </p>
                </blockquote>
              </div>
            </Col>
            <Col lg={6}>
              <div className="vision-mission-visual h-100 position-relative">
                <img
                  src={visionImage}
                  alt="Businessperson Holding Glowing Light Bulb Symbolizing Innovation"
                  className="img-fluid rounded shadow-lg w-100 h-100"
                />
                <div className="image-caption-overlay">
                  <div className="overlay-content">
                    <h3>Our Vision in Action</h3>
                    <p>Student-centric learning environment</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section ptb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={6} className="order-lg-2 mb-4 mb-lg-0">
              <div className="mission-image-container text-center">
                <img
                  src={missionIcon}
                  alt="Mission"
                  className="mission-icon mb-4"
                  width="120"
                />
                <h2 className="section-title modern-title text-blue">
                  Our Mission
                </h2>
                <blockquote className="blockquote m-0 vision-mission-statement">
                  <p className="mb-0 fs-4 fw-bold fst-italic">
                    "To create strong academic transaction with state-of-the-art
                    technology and continual research that leads to value
                    innovation and creation, resulting in all-round sustainable
                    development."
                  </p>
                </blockquote>
              </div>
            </Col>
            <Col lg={6} className="order-lg-1">
              <div className="vision-mission-visual h-100 position-relative">
                <img
                  src={missionImage}
                  alt="Businessperson Holding Magnifying Glass Over Digital Target Icons"
                  className="img-fluid rounded shadow-lg w-100 h-100"
                />
                <div className="image-caption-overlay">
                  <div className="overlay-content">
                    <h3>Our Mission at Work</h3>
                    <p>Implementing cutting-edge learning methodologies</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Core Values */}
      <section className="values-section ptb-50 bg-blue">
        <div className="container-xxl">
          <div className="text-center mb-5">
            <img
              src={valuesIcon}
              alt="Core Values"
              className="values-icon mb-4"
              width="120"
            />
            <h2 className="section-title modern-title text-white">
              Our Core Values
            </h2>
            <p className="modern-subtitle text-white">
              The foundation that shapes our purpose, performance, and progress.
            </p>
          </div>

          <Row className="g-4">
            {coreValues.map((value, index) => (
              <Col md={6} lg={4} key={index}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="text-center p-4">
                    <div className="value-number mb-3">
                      <span
                        className="bg-blue text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <i className="ti ti-sparkles"></i>
                      </span>
                    </div>
                    <Card.Title className="h6 fw-bold text-blue">
                      {value.title}
                    </Card.Title>
                    <Card.Text className="fs-5">{value.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Implementation Section */}
      <section className="implementation-section ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center text-blue mb-5">
            Putting Our Vision Into Practice
          </h2>
          <Row className="g-4">
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">
                  Pathways to Educational Excellence
                </h5>
                <p>
                  Empowering students through organized, future-oriented, and
                  effective academic pathways.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">Academic Excellence</h5>
                <p>
                  Ensuring demanding learning, excellent teaching, and high
                  academic performance standards.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">Continuous Research</h5>
                <p>
                  Progressing knowledge through continuous exploration,
                  discovery, and practical application.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">
                  State-of-the-Art Technology
                </h5>
                <p>
                  Rearranging sophisticated digital tools to support
                  contemporary teaching and learning experiences.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">
                  Building Humanity & Cultivating Wisdom
                </h5>
                <p>
                  Inculcating values, compassion, and global citizenship through
                  integral education.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">Sustainable Development</h5>
                <p>
                  Incorporating sustainability values in academics, operations,
                  and outreach.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">Value Creation</h5>
                <p>
                  Creating measurable educational value that positively impacts
                  students and society.
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="implementation-card p-4 h-100 bg-white rounded shadow border-start border-blue border-4">
                <h5 className="text-blue fw-bold">Innovation</h5>
                <p>
                  Encouraging innovative thinking, problem-solving, and
                  revolutionary educational approaches.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="m-0">
            <Col md={12}>
              <img
                src={researchLab}
                alt="Group of Students Studying on Laptop and a Graduate Holding Diploma"
                className="img-fluid rounded shadow-lg"
                style={{ maxHeight: "400px" }}
              />
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default VisionMission;
